const alternativeSites: string[][] = [
    ['en-us', '99designs.com'],
    ['es-us', 'es.99designs.com'],
    ['en-au', '99designs.com.au'],
    ['en-ca', '99designs.ca'],
    ['en-gb', '99designs.co.uk'],
    ['en-ie', '99designs.ie'],
    ['de-de', '99designs.de'],
    ['en-de', 'en.99designs.de'],
    ['en-dk', '99designs.dk'],
    ['fr-fr', '99designs.fr'],
    ['en-fr', 'en.99designs.fr'],
    ['it-it', '99designs.it'],
    ['en-it', 'en.99designs.it'],
    ['en-no', '99designs.no'],
    ['nl-nl', '99designs.nl'],
    ['en-nl', 'en.99designs.nl'],
    ['pt-br', '99designs.com.br'],
    ['en-br', 'en.99designs.com.br'],
    ['pt-pt', '99designs.pt'],
    ['en-pt', 'en.99designs.pt'],
    ['es-cl', '99designs.cl'],
    ['en-cl', 'en.99designs.cl'],
    ['es-co', '99designs.com.co'],
    ['en-co', 'en.99designs.com.co'],
    ['es-mx', '99designs.com.mx'],
    ['en-mx', 'en.99designs.com.mx'],
    ['es-es', '99designs.es'],
    ['en-es', 'en.99designs.es'],
    ['ja-jp', '99designs.jp'],
    ['en-jp', 'en.99designs.jp'],
    ['de-ch', '99designs.ch'],
    ['it-ch', 'it.99designs.ch'],
    ['fr-ch', 'fr.99designs.ch'],
    ['en-ch', 'en.99designs.ch'],
    ['en-hk', '99designs.hk'],
    ['en-sg', '99designs.com.sg'],
    ['nl-be', '99designs.be'],
    ['fr-be', 'fr.99designs.be'],
    ['en-be', 'en.99designs.be'],
    ['de-at', '99designs.at'],
    ['en-at', 'en.99designs.at'],
];

export default alternativeSites;
